import React from "react";
import { Col, Row } from "antd";
import CheckBlogItem from "./../../Common/Components/CheckBlogItem";
import { DraggableBox } from "modules/Common/Components/DraggableBox";
import CheckBlogItemNoImage from "modules/Common/Components/CheckBlogItemNoImage";

const ArticlesGridContainer = (props) => {
  const { articles, imgHeight, imgWidth, smallBlog, articleSpan, inEditionSmartSourced, isCampaign } = props;
  return (
    <React.Fragment>
      <Row gutter={{ xs: 24, sm: 24, md: 24, lg: 24 }}>
        {articles.map((article, index) => (
          <Col className="gutter-row" span={articleSpan} key={index}>
            <DraggableBox articleId={article.id} blogItem={article}>
              {article.image_url === "" ? (
                <CheckBlogItemNoImage
                  isCampaign={isCampaign}
                  {...(props.top && index === 0
                    ? {
                        checkboxId: "blogCheckBoxId",
                      }
                    : {})}
                  {...(props.top && index === 0
                    ? {
                        checkBlogId: "checkBlogIdOnBoarding",
                      }
                    : {})}
                  articleId={article.id}
                  smallBlog={smallBlog}
                  imgHeight={imgHeight}
                  imgWidth={imgWidth}
                  imgHeightSm={articleSpan === 12 ? "165px" : "120px"}
                  title={article.title}
                  imgUrl={article.image_url}
                  publishDate={article.publish_date}
                  website={article.website}
                  entities={article.entities}
                  description={article.description}
                  link={article.link}
                  isCurated={article.is_curated}
                  isCMS={article.is_cms}
                  isFav={article.is_favourite}
                  views={article.views}
                  hybridContainer={false}
                  inEditionSmartSourced={inEditionSmartSourced}
                  companyName={article.companyName}
                  categoryColor={article.alerts}
                  categoryTitle={article.alerts}
                  fullDescription={article.fullDescription}
                />
              ) : (
                <CheckBlogItem
                  isCampaign={isCampaign}
                  {...(props.top && index === 0
                    ? {
                        checkboxId: "blogCheckBoxId",
                      }
                    : {})}
                  {...(props.top && index === 0
                    ? {
                        checkBlogId: "checkBlogIdOnBoarding",
                      }
                    : {})}
                  articleId={article.id}
                  smallBlog={smallBlog}
                  imgHeight={imgHeight}
                  imgWidth={imgWidth}
                  imgHeightSm={articleSpan === 12 ? "165px" : "120px"}
                  title={article.title}
                  imgUrl={article.image_url}
                  publishDate={article.publish_date}
                  website={article.website}
                  entities={article.entities}
                  description={article.description}
                  link={article.link}
                  isCurated={article.is_curated}
                  isCMS={article.is_cms}
                  isFav={article.is_favourite}
                  inEditionSmartSourced={inEditionSmartSourced}
                  companyName={article.companyName}
                  categoryColor={article.alerts}
                  categoryTitle={article.alerts}
                  fullDescription={article.fullDescription}
                />
              )}
            </DraggableBox>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  );
};

export default ArticlesGridContainer;
